<mat-drawer-container class="filter-drawer-container">
  <mat-drawer #drawer mode="over" position="end" [opened]="isOpen()" (closed)="close()">
    <div class="filter-drawer">
      <div class="filter-drawer__header">
        <h2 class="filter-drawer__title">{{ 'inventory.filter.title' | translate }}</h2>

        <button class="filter-drawer__close-button" mat-icon-button type="button" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="filter-drawer__content">
        @if (activeCriteria().length > 0) {
          <div class="active-criteria">
            @for (criterion of activeCriteria(); track criterion.key) {
              <span class="active-criteria__chip">
                <span>{{ criterion.label | translate }}:</span>
                <strong class="active-criteria__chip-value">{{ criterion.value }}</strong>
              </span>
            }
          </div>
        }

        <form [formGroup]="filterForm">
          @for (filter of filtersConfig; track filter.key) {
            @if (filter.type === 'text') {
              <mat-expansion-panel class="filter-section">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="filter-section__header-content">
                      <h3 class="filter-section__title">
                        {{ filter.title | translate }}
                      </h3>

                      @if (filterForm.get(filter.key)?.value) {
                        <button
                          type="button"
                          class="reset-link"
                          (click)="resetSection(filter.key); $event.stopPropagation()"
                        >
                          {{ 'inventory.filter.resetAll' | translate }}
                        </button>
                      }
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <mat-form-field appearance="outline" class="full-width">
                  <input
                    matInput
                    [formControlName]="filter.key"
                    [placeholder]="filter.placeholder || '' | translate"
                  />
                </mat-form-field>
              </mat-expansion-panel>
            } @else if (filter.type === 'range') {
              <mat-expansion-panel class="filter-section">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="filter-section__header-content">
                      <h3 class="filter-section__title">
                        {{ filter.title | translate }}
                      </h3>

                      @if (
                        filterForm.value[filter.key + 'Min'] !== filter.min ||
                        filterForm.value[filter.key + 'Max'] !== filter.max
                      ) {
                        <button
                          type="button"
                          class="reset-link"
                          (click)="resetSection(filter.key); $event.stopPropagation()"
                        >
                          {{ 'inventory.filter.resetAll' | translate }}
                        </button>
                      }
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="range-inputs">
                  <mat-form-field appearance="outline" class="range-input">
                    <input
                      matInput
                      type="number"
                      [formControlName]="filter.key + 'Min'"
                      [placeholder]="'inventory.filter.from' | translate"
                      (input)="onRangeInputChange(filter.key + 'Min', filter.key + 'Max')"
                    />
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="range-input">
                    <input
                      matInput
                      type="number"
                      [formControlName]="filter.key + 'Max'"
                      [placeholder]="'inventory.filter.to' | translate"
                      (input)="onRangeInputChange(filter.key + 'Min', filter.key + 'Max')"
                    />
                  </mat-form-field>
                </div>

                <mat-slider
                  matSliderRange
                  class="range-slider"
                  [min]="filter.min"
                  [max]="filter.max"
                  [step]="filter.step"
                >
                  <input
                    matSliderStartThumb
                    [value]="filterForm.get(filter.key + 'Min')?.value ?? filter.min"
                    (valueChange)="
                      onRangeSliderChange($event, filter.key + 'Min', filter.key + 'Max', 'min')
                    "
                  />

                  <input
                    matSliderEndThumb
                    [value]="filterForm.get(filter.key + 'Max')?.value ?? filter.max"
                    (valueChange)="
                      onRangeSliderChange($event, filter.key + 'Max', filter.key + 'Min', 'max')
                    "
                  />
                </mat-slider>
              </mat-expansion-panel>
            } @else {
              <mat-expansion-panel class="filter-section">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="filter-section__header-content">
                      <h3 class="filter-section__title">
                        {{ filter.title | translate }}
                      </h3>

                      @if (filterForm.get(filter.key)?.value) {
                        <button
                          type="button"
                          class="reset-link"
                          (click)="resetSection(filter.key); $event.stopPropagation()"
                        >
                          {{ 'inventory.filter.resetAll' | translate }}
                        </button>
                      }
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                @if (filter.options().length !== 0) {
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-select
                      [placeholder]="filter.placeholder | translate"
                      [formControlName]="filter.key"
                      (selectionChange)="applyFilters()"
                    >
                      @for (option of filter.options(); track option) {
                        @let obj = isObject(option);

                        <mat-option [value]="obj ? option.id : option">
                          {{ obj ? option.name : option }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                } @else {
                  <span class="empty-message">
                    {{ filter.emptyPlaceholder | translate }}
                  </span>
                }
              </mat-expansion-panel>
            }
          }

          <mat-expansion-panel class="filter-section">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="filter-section__header-content">
                  <h3 class="filter-section__title">
                    {{ 'inventory.filter.sortBy' | translate }}
                  </h3>

                  @if (filterForm.get('sortBy')?.value || filterForm.get('sortOrder')?.value) {
                    <button
                      type="button"
                      class="reset-link"
                      (click)="resetSection('sortBy'); $event.stopPropagation()"
                    >
                      {{ 'inventory.filter.resetAll' | translate }}
                    </button>
                  }
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="sort-fields">
              <mat-form-field appearance="outline" class="full-width">
                <mat-select
                  [placeholder]="'inventory.filter.sortField' | translate"
                  formControlName="sortBy"
                  (selectionChange)="onSortFieldChange()"
                >
                  @for (option of sortOptions; track option.value) {
                    <mat-option [value]="option.value">
                      {{ option.label | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-select
                  [placeholder]="'inventory.filter.sortDirection' | translate"
                  formControlName="sortOrder"
                  (selectionChange)="applyFilters()"
                >
                  @for (option of sortDirections; track option.value) {
                    <mat-option [value]="option.value">
                      {{ option.label | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </mat-expansion-panel>
        </form>
      </div>

      @if (hasActiveCriteria()) {
        <div class="filter-drawer__footer">
          <button type="button" class="btn-white reset-button" (click)="resetFilters()">
            {{ 'inventory.filter.resetFiltersAndOrdering' | translate }}
          </button>
        </div>
      }
    </div>
  </mat-drawer>
</mat-drawer-container>
